import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';           // ← import it
import { HomePage } from './pages/HomePage';
import { MatchPage } from './pages/MatchPage';
import { MatchesPage } from './pages/MatchesPage';
import { TeamsPage } from './pages/TeamsPage';
import { HighlightsPage } from './pages/HighlightsPage';
import { AboutPage } from './pages/StaticPages';
import { PrivacyPage, CookiePage } from './pages/LegalPages';

function App() {
  return (
    <BrowserRouter>
      <Layout>                                             {/* ← wrap everything here */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/matches" element={<MatchesPage />} />
          <Route path="/match/:id" element={<MatchPage />} />
          <Route path="/teams" element={<TeamsPage />} />
          <Route path="/highlights" element={<HighlightsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookies" element={<CookiePage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;